// extracted by mini-css-extract-plugin
export default {"wrap":"is-z","fullWidth":"js-z","items":"ks-z","featureCss":"ls-z","disabled":"ms-z","imgCss":"ns-z"};